export const uses24HourClock = () => true;
export const getLocales = () => {
  return [];
};
